import Blue from "../core";

new Blue({
	name: 'View Toggle',
	selector: ".view-toggle",
	setup(container) {
		const toggleBtns = [...container.querySelectorAll(".view-toggle__btn")];
		const indicator = container.querySelector(".view-toggle__indicator");
		const indicatorHeight = indicator.offsetHeight;
		const viewsContainer = document.querySelector(".search-page__views") || false;
		let loaded = false;

		const positionIndicator = () => {
			const currentActiveOption = container.querySelector(".view-toggle__option.active");
			const optionHeight = currentActiveOption.offsetHeight;
			const optionOffsetValue = optionHeight / 2 - indicatorHeight / 2;
			const newTopValue = optionOffsetValue + currentActiveOption.offsetTop;
			const start = indicator.offsetTop;
			indicator.style.top = newTopValue + "px";
			const end = indicator.offsetTop;
			indicator.animate(
				[
					{top: `${start}px`},
					{top: `${end}px`}
				], 
				{
					duration: 160,
					easing: 'linear'
				}
			);

			if (!loaded) {
				indicator.style.opacity = "1";
				loaded = true;
			}
		}

		positionIndicator();

		const switchView = () => {
			const views = [...viewsContainer.querySelectorAll(".search-page__view ")];
			views.forEach(v => {v.classList.toggle("active")});
		}

		toggleBtns.forEach(btn => {
			this.$addEvents(btn, "click.prevent", () => {
				const wrapper = btn.closest(".view-toggle__option");
				if (wrapper.matches(".active")) return;
				container.querySelector(".view-toggle__option.active").classList.remove("active");
				wrapper.classList.add("active");
				if (viewsContainer) switchView();
				positionIndicator();
			});
		})
	}
});